import { render, staticRenderFns } from "./scale.vue?vue&type=template&id=fc52d348&scoped=true&"
import script from "./scale.vue?vue&type=script&lang=js&"
export * from "./scale.vue?vue&type=script&lang=js&"
import style0 from "./scale.vue?vue&type=style&index=0&id=fc52d348&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc52d348",
  null
  
)

component.options.__file = "scale.vue"
export default component.exports